import React, { useState } from 'react'
// import { connect } from 'react-redux'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

const CloseAccount = ({ closeAccount }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Typography variant="subtitle1" gutterBottom>
        Account
      </Typography>
      <Box>
        <Typography style={{ display:'inline-block', paddingRight: 16 }}>Close account:</Typography>
        <Button variant="contained" color="inherit" onClick={ () => setOpen(true) }>Close</Button>
      </Box>
      <Modal open={ open } onClose={() => setOpen(false)}>
        <Box style={{ width: '100dvw', height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Card>
            <CardContent>
              <Typography variant="h6">Do you want to close your account? Your mindfiles will be deleted. This cannot be undone.</Typography>
              <Box mt={ 3 } >
                <Button variant="contained" color="primary" onClick={ closeAccount }>Close</Button>
                <Button variant="contained" color="secondary" onClick={ () => setOpen(false) } style={{ marginLeft: 16 }}>Cancel</Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Modal>
    </>
  )
}

export default CloseAccount
